module.exports = __webpack_public_path__ + "static/media/ic_hide_web_rtv.8da1fe1f.svg";